import { trigger, state, style, transition, animate } from '@angular/animations';

export const HighlightAnimation = trigger('highlight', [
  state('inactive', style({backgroundColor: 'rgba(255, 255, 255, 0.0)'})),
  state('active', style({backgroundColor: 'rgba(252, 228, 236, 0.75)'})),
  transition('inactive => active', [
    style({backgroundColor: 'rgba(255, 255, 255, 0.0)'}),
    animate('0.25s ease-in', style({backgroundColor: 'rgba(252, 228, 236, 0.75)'}))
  ]),
  transition('active => inactive', [
    style({backgroundColor: 'rgba(252, 228, 236, 0.75)'}),
    animate('1.0s ease-out', style({backgroundColor: 'rgba(255, 255, 255, 0.0)'}))
  ])
]);


// WEBPACK FOOTER //
// ./src/app/shared/highlight.animation.ts